/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";

import { IRetornoCelular } from "../../../interface/celular";
import { InfoCelular } from "../../../components/InfoCelular";
import { useAuth } from "../../../hooks/auth";

interface IDados {
  dados: IRetornoCelular;
  imei: string;
}

const styleInputs = {
  display: "flex",
  flexDirection: "row",
  gap: 1,
};

export const FichaCelular: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();

  const [loading, setLoading] = useState(false);

  const { url } = user!.sistemas.filter((s) => {
    return s.id_sistema === 1 ? s.url : false;
  })[0];
  const storedToken = sessionStorage.getItem("@webSDS:token");

  const [dados, setDados] = useState<IRetornoCelular>();
  const dadosCelular = history?.location.state as IDados;

  const consultaCelular = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${url}/wsAlertaCel/BuscarPorImeiNew1/${dadosCelular.imei}`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      setDados(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (dadosCelular.dados) {
      setDados(dadosCelular.dados);
    }
    if (dadosCelular.imei !== dados) {
      consultaCelular();
    }
  }, []);

  const imprimir = () => {
    window.print();
  };

  const voltar = () => {
    history.goBack();
  };

  const theme = MUI.useTheme();

  return (
    <MUI.Stack
      pt={[2, 0]}
      flexDirection="row"
      width="100%"
      height="80vh"
      overflow="auto"
      sx={{
        "@media print": {
          overflow: "hidden !important",
          height: "100%",
          pageBreakInside: "avoid",
        },
      }}
    >
      <MUI.Stack p={2} flex={1}>
        <MUI.Stack
          mb={1}
          gap={[1, 0]}
          width="100%"
          flexDirection={["column", "row"]}
          justifyContent="space-between"
          sx={{
            displayPrint: "none",
          }}
        >
          <MUI.Button
            variant="contained"
            startIcon={<Icon.KeyboardReturn />}
            onClick={voltar}
          >
            Voltar para pesquisa
          </MUI.Button>
          <MUI.Button variant="contained" onClick={imprimir}>
            Imprimir
          </MUI.Button>
        </MUI.Stack>

        {!loading ? (
          <MUI.Stack pb={2}>
            <MUI.Typography
              bgcolor={theme.palette.secondary.light}
              variant="h6"
            >
              Informações do Celular
            </MUI.Typography>
            <MUI.Divider
              sx={{
                borderWidth: 1.5,
                backgroundColor: `${theme.palette.secondary.contrastText}`,
              }}
            />

            <MUI.Grid container spacing={1} py={1}>
              <MUI.Grid xs={12} md={6} sm={6} item sx={styleInputs}>
                <MUI.Typography fontWeight="bold" variant="body1">
                  Situação:
                </MUI.Typography>
                {dados && dados.APARELHO_ALERTA && !dados.APARELHO_INFOPOL && (
                  <MUI.Typography
                    variant="body1"
                    sx={{
                      background:
                        dados.APARELHO_ALERTA?.SITUACAO === "NÃO ALERTADO"
                          ? "#37b449"
                          : "#c53030",
                      borderRadius: "5px",
                      color: "#FFF",
                      padding: "0.1rem 0.5rem",
                    }}
                  >
                    {dados.APARELHO_ALERTA.SITUACAO}
                  </MUI.Typography>
                )}
                {dados && dados.APARELHO_INFOPOL && !dados.APARELHO_ALERTA && (
                  <MUI.Typography
                    variant="body1"
                    sx={{
                      background:
                        dados.APARELHO_INFOPOL?.SITUACAO === "RECUPERADO"
                          ? "#37b449"
                          : "#c53030",
                      borderRadius: "5px",
                      color: "#FFF",
                      padding: "0.1rem 0.5rem",
                    }}
                  >
                    {dados.APARELHO_INFOPOL.SITUACAO}
                  </MUI.Typography>
                )}
                {dados && dados.APARELHO_ALERTA && dados.APARELHO_INFOPOL && (
                  <MUI.Typography
                    variant="body1"
                    sx={{
                      background:
                        dados.APARELHO_INFOPOL?.SITUACAO === "RECUPERADO"
                          ? "#37b449"
                          : "#c53030",
                      borderRadius: "5px",
                      color: "#FFF",
                      padding: "0.1rem 0.5rem",
                    }}
                  >
                    {dados.APARELHO_INFOPOL.SITUACAO}
                  </MUI.Typography>
                )}
              </MUI.Grid>
            </MUI.Grid>

            <MUI.Divider />

            {dados?.APARELHO_ALERTA && (
              <InfoCelular aparelhoAlerta={dados.APARELHO_ALERTA} />
            )}

            {dados?.APARELHO_INFOPOL && dados.DADOS_INFOPOL && (
              <>
                <InfoCelular aparelhoInfopol={dados.APARELHO_INFOPOL} />
                <InfoCelular dadosInfopol={dados.DADOS_INFOPOL} />
              </>
            )}
          </MUI.Stack>
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </MUI.Stack>
  );
};
